import Swiper from "swiper";
import { A11y, FreeMode, Parallax } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".team-slider");
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, FreeMode, Parallax],
    slidesPerView: 1.1,
    spaceBetween: 24,
    parallax: true,
    freeMode: {
      enabled: true,
      momentumRatio: 0.6,
      momentumVelocityRatio: 0.3,
      minimumVelocity: 0.1,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 2.1,
        spaceBetween: 24,
      },
    },
    on: {
      touchMove: (_, event) => {
        fireEvent("swiper:drag", document.documentElement, event);
      },
      touchEnd: (_, event) => {
        fireEvent("swiper:dragend", document.documentElement, event);
      },
      resize: (swiper) => {
        if (swiper.isLocked) {
          swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
        } else {
          swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
        }
      },
    },
  });
});
